import o from "./ghl-ui.es1200.js";
import l from "./ghl-ui.es787.js";
function f(a) {
  for (var t = l(a), r = t.length; r--; ) {
    var e = t[r], i = a[e];
    t[r] = [e, i, o(i)];
  }
  return t;
}
export {
  f as default
};
